<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش فروش بوفه </span>

    </div>

</div>

<div dir="rtl" class="form w-100 row gx-2 px-2">

    <form class="col-md-3" [formGroup]="dateFilter">

        <label> از تاریخ </label>

        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

            <input dir="ltr" type="text" formControlName="strSDate" class="form-control " />

        </ng-persian-datepicker>

    </form>

    <form class="col-md-3" [formGroup]="dateFilter">

        <label> تا تاریخ </label>

        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

            <input dir="ltr" type="text" formControlName="strEDate" class="form-control " />

        </ng-persian-datepicker>

    </form>

    <div class="col-12 col-md-2 mt-2 mt-md-0 d-flex align-items-end  justify-content-end ">

        <button class="btn mx-md-2 px-5 btn-primary w-100 " type="button" (click)="search_SoldBuffet()">جستجو</button>

    </div>

</div>

<main class=" rtl px-2 mt-2 p-2">

    <span class="px-2" *ngIf="list_Sold.length > 0"> تعداد  <span class="text-danger fw-bold ">{{list_Sold.length | faNum}}</span> مورد یافت شد </span>

    <div class="row gx-2 mt-2 border border-2 p-2">

        <div class="col-12 col-md-10 mt-3 mb-4">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div *ngIf="list_Sold.length > 0" class="col-12 col-md-2 d-flex align-items-center justify-content-end">

            <button class="btn btn-success mx-2" (click)="exportExcel()">
    
                <span> خروجی اکسل </span>
    
                <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>
    
            </button>
          
        </div>

        <div class="table-responsive" style="max-height: 68vh;">

            <table class="table table-striped" id="Export_Excel">
    
                <thead class="position-sticky top-0 bg-white">
    
                    <tr class="col-12 text-center">

                        <th> # </th>

                        <th> عنوان </th>

                        <th> تعداد </th>

                        <th> جمع مبلغ </th>

                    </tr>
    
                </thead>
    
                <tbody>
    
                    <tr class="col-12 text-center" *ngFor="let item of list_Sold;let i = index">
    
                        <th> {{ i + 1 | faNum }} </th>

                        <td>{{item.strTitle | faNum}}</td>

                        <td>{{item.iCount.toLocaleString() + ' عدد ' | faNum}}</td>

                        <td>{{item.iPrice.toLocaleString() + ' تومان ' | faNum}}</td>
   
                    </tr>
    
                </tbody>
    
            </table>

            <div *ngIf="list_Sold.length > 0" class="totalPrice_container text-end">

                <b> سرجمع : {{totalPrice.toLocaleString() + ' تومان ' | faNum}} </b>
            </div>
    
        </div>

    </div>

</main>

<ng-container *ngIf="isLoading" >

    <div class="school_loading" style="z-index: 10000000000000000000000000000000000;">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>